/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { YoutubeIntegrationGetStationStatsCountryViewersQueryResponse, YoutubeIntegrationGetStationStatsCountryViewersPathParams, YoutubeIntegrationGetStationStatsCountryViewersQueryParams, YoutubeIntegrationGetStationStatsCountryViewers401, YoutubeIntegrationGetStationStatsCountryViewers403 } from "../models/YoutubeIntegrationGetStationStatsCountryViewers";

export function getYoutubeIntegrationGetStationStatsCountryViewersUrl(station: YoutubeIntegrationGetStationStatsCountryViewersPathParams["station"]) {
  const res = { method: 'GET', url: `/youtube-integration/v1/stats/viewers/${station}/country` as const }
  return res
}

/**
 * @description Returns stats for every channel in the live-viewers catalog whose `countryCode` matches this station’s channel (same scope as `ChannelRepository.findByCountry`). `metadata.channels[*].isSelf` marks this station’s `youtubeChannelId`.
 * @summary Viewer time series for same-country catalog channels
 * {@link /youtube-integration/v1/stats/viewers/:station/country}
 */
export async function youtubeIntegrationGetStationStatsCountryViewers(station: YoutubeIntegrationGetStationStatsCountryViewersPathParams["station"], params: YoutubeIntegrationGetStationStatsCountryViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<YoutubeIntegrationGetStationStatsCountryViewersQueryResponse, ResponseErrorConfig<YoutubeIntegrationGetStationStatsCountryViewers401 | YoutubeIntegrationGetStationStatsCountryViewers403>, unknown>({ method : "GET", url : getYoutubeIntegrationGetStationStatsCountryViewersUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}